function adjustReChargeElements() {
    const disclaimerSourceElement = document.querySelector('.rc_popup__how_it_works');
    const disclaimerTargetElement = document.querySelector('.rc-selling-plans');
    const popup = document.querySelector('.rc_popup');
    const subsave = document.querySelector('.rc_widget__option--subsave');
    const discount = document.querySelector('[data-label-discount]')?.textContent;
    const subsaveTextElement = subsave?.querySelector('.rc-option__text');
    const priceElements = document.querySelectorAll('.rc-option__price');
    const moneyFormat = window.Shopify?.money_format || '${{amount}}';
    const sellingLabel = document.querySelector('.rc-selling-plans__label');

    const oneTime = document.querySelector('.rc-option__onetime');
    const oneTimeText = oneTime?.querySelector('.rc-option__text');
    
    if (disclaimerSourceElement && disclaimerTargetElement) {
        disclaimerSourceElement.innerHTML = customRechargeText.disclaimerText || disclaimerSourceElement.innerHTML;
        disclaimerTargetElement.prepend(disclaimerSourceElement.cloneNode(true));
        if (popup) {
            popup.remove();
        }

        if (oneTimeText) {
            const oneTimeInfo = document.createElement('span');
            oneTimeInfo.className = 'rc_subsave__recurring-info';
            oneTimeInfo.textContent = customRechargeText.servingsPerBag || '15 Servings';
            oneTimeText.appendChild(oneTimeInfo);
        }

        if (subsave) {
            const discountSpan = document.createElement('span');
            discountSpan.className = 'rc_subsave__discount-info';
            discountSpan.textContent = customRechargeText.rechargeHeading || `Save up to ${discount} on every DELIVERY`;
            subsave.prepend(discountSpan);
        }
        
        if (subsaveTextElement) {
            const recurringText = document.createElement('span');
            recurringText.className = 'rc_subsave__recurring-info';
            recurringText.textContent = customRechargeText.servingsPerBag || '15 Servings';
            subsaveTextElement.appendChild(recurringText);
        }

        if (sellingLabel) {
            const rechargeLabel = document.createElement('label');
            rechargeLabel.className = 'rc-selling-plans__label';
            rechargeLabel.textContent = customRechargeText.deliveryFrequencyLabel || 'Delivers every';
            sellingLabel.replaceWith(rechargeLabel);
        }

        const fullPrice = Array.from(priceElements)
            .find(el => !el.closest('.rc_widget__option--subsave'))
            ?.textContent || '0';

        priceElements.forEach(el => {
            const price = parseFloat(el.textContent.replace(/[^0-9.]/g, ''));
            const pricePerServing = (price / 15).toFixed(2);
            const formattedPricePerServing = moneyFormat.replace('{{amount}}', pricePerServing);
            let fullPriceEl = '';
            let text = '';

            if (el.closest('.rc_widget__option--subsave')) {
                text = 'as low as';
                pricePerServingText = customRechargeText.pricePerServingLabel || `${text} ${formattedPricePerServing}/serving`;
                fullPriceEl = `<s class="rc_subsave__full-price">${customRechargeText.regularPrice || fullPrice}</s>`;
            } else {
                text = 'only';
                pricePerServingText = customRechargeText.pricePerServingOnlyLabel || `${text} ${formattedPricePerServing}/serving`;
            }

            el.innerHTML = `${fullPriceEl}${el.textContent}/Bag <span class="rc_subsave__price-per-serving">${pricePerServingText}</span>`;
        });

        return true;
    }
    
    return false;
}

if (!adjustReChargeElements()) {
    const observer = new MutationObserver(() => {
        if (adjustReChargeElements()) {
            observer.disconnect();
        }
    });
    
    observer.observe(document.body, { childList: true, subtree: true });
}


document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector(".supplement-facts__bundle");
  if (!container) return;
  const buttons = container.querySelectorAll(".tab-product-list__link");
  const holders = container.querySelectorAll(".page-holder");
  const headBg = container.querySelector(".supplement-facts__head-bg");

  if (!buttons.length || !holders.length) return;

  // Core function: activate tab logic
  function activateTab(targetId, targetColor, buttonEl) {
    const targetHolder = document.getElementById(targetId);
    if (!targetHolder) return;

    // Remove .active from all tab items
    container.querySelectorAll(".tab-product-list__item").forEach((item) => {
      item.classList.remove("active");
    });

    // Add .active to the parent of the clicked/active button
    const parentItem = buttonEl.closest(".tab-product-list__item");
    if (parentItem) {
      parentItem.classList.add("active");
    }

    // Hide all page-holder elements
    holders.forEach((holder) => {
      holder.classList.add("visually-hidden");
    });

    // Show the target page-holder
    targetHolder.classList.remove("visually-hidden");

    // Change background color
    if (headBg && targetColor) {
      headBg.style.backgroundColor = targetColor;
    }
  }

  // Click handler for desktop & mobile
  buttons.forEach((button) => {
    button.addEventListener("click", function () {
      activateTab(this.dataset.id, this.dataset.color, this);
    });
  });

  // -----------------------------
  // Swiper init only under 767px
  // -----------------------------

  let swiperInstance = null;
  const mq = window.matchMedia("(max-width: 767px)");

  function enableSwiper() {
    swiperInstance = new Swiper(".tab-product-swiper", {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },

      on: {
        slideChange: function () {
          const activeSlide = this.slides[this.activeIndex];
          if (!activeSlide) return;

          const btn = activeSlide.querySelector(".tab-product-list__link");
          if (!btn) return;

          activateTab(btn.dataset.id, btn.dataset.color, btn);
        },
      },
    });
  }

  function disableSwiper() {
    if (swiperInstance) {
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    }
  }

  function handleScreen(e) {
    if (e.matches) {
      // Mobile — enable swiper
      if (!swiperInstance) enableSwiper();
    } else {
      // Desktop — disable swiper
      disableSwiper();
    }
  }

  // Run on load
  handleScreen(mq);

  // Run on resize
  mq.addEventListener("change", handleScreen);
});

// handler for title
function handleize(str) {
  return str
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

document.addEventListener("DOMContentLoaded", function () {
  const variantButtons = document.querySelectorAll(".multiple-variants__item");

  variantButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const variantTitle = this.dataset.variantTitle;
      const mediaItems = document.querySelectorAll(".swiper-slide-thumb");

      mediaItems.forEach((slide) => {
        const alt = slide.dataset.alt;

        if (alt && handleize(alt) === handleize(variantTitle)) {
          // go to this swiper slide
          const index = Array.from(mediaItems).indexOf(slide);
          const mainSwiper = document.querySelector(".product-swiper").swiper;
          const thumbSwiper = document.querySelector(
            ".product-swiper-thumbs",
          ).swiper;
          if (mainSwiper) mainSwiper.slideTo(index);
          if (thumbSwiper) thumbSwiper.slideTo(index);
        }
      });
    });
  });
});
